import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Autocomplete,
  TextField,
  InputLabel,
  Button,
  Select,
  MenuItem,
  FormControl,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { handleValidationForm } from "utils/utils";
import { BootstrapInput , CustomSelect } from "./CommonFormStyle";
import Loader from "components/loader/Loader";
import CommonCropUpload from "components/commonCropUpload/CommonCropUpload";
import profile from "assets/images/SubVendorLogo.svg";
import cloudArrowUp from "assets/images/cloudArrowUp.svg";
import lockicon from "assets/images/lockicon.svg";

export default function CommonForm(props) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({ defaultValues: props?.defaultValues, mode: "onChange" });
  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(
    props?.selectType === "edit" ? false : true
  );
  const formData = props?.formData ? props?.formData : [];
  // ---Country Code---
  const [country, setCountry] = useState("+91");
  const [facilities, setFacilities] = useState(
    props?.defaultValues?.facilities || []
  );

  const handleInput = (e, value) => {
    clearErrors(e.target.name);
    let data = {};
    if (value && value !== undefined) {
      data[e.target.name] = value;
    } else {
      data[e.target.name] = e.target.value;
    }
    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);

    if (validationData.formIsValid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  const handleAuto = (e, value) => {
    setFacilities(value);
  };

  const handleChange = (event) => {
    setCountry(event.target.value);
  };

  const handleEditIconClick = (id) => {
    props.handleEditIconClick(id);
  };

  // ---Form Validation---

  const onSubmit = (data) => {
    // handleValidationForm
    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);

    if (validationData.formIsValid) {
      if (facilities?.length > 0) {
        const val = { ...data, facilities: facilities?.map((list) => list.id) };
        props.onSubmittBtn(val, country);
      } else {
        props.onSubmittBtn(data, country);
      }
    }
  };

  const handleClose = () => {
    props.handleClose();
  };


  const handleOnError = (e) => {
    e.target.src = profile;
  };

  return (
    <div>
      <div>
        {/* "handleSubmit" will validate your inputs before invoking "onSubmit"  */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={`${
            props.type === "complianceupload" ? "flexDirection" : null
          }`}
        >
          {formData?.map((ele, idx) => (   
            <div key={ele?.name}>
                {ele.type === 'file' ? (
                           <CommonCropUpload 
                           name={ele?.name}
                           defaultValues={props?.defaultValues}
                           onImageHandleChange={props?.onImageHandleChange}/>):
              (ele?.name !== "InsuranceFile" &&
                ele?.name !== "PollutionFile" &&
                ele?.name !== "RCBookFile") && (
                  <Box
                  className={idx === formData?.length - 1 ? 'boxOutline' : 'boxMarginBottom'}
                    key={ele?.name}
                  >
                    <FormControl variant="standard">
                      <p className="commonformLabel">
                        {ele?.label}
                        {(ele?.required || ele?.starVal) && (
                          <span className="colorRed">{ele?.star || "*"}</span>
                        )}
                      </p>
                      <Box className="dflex">
                        {ele?.countrycode && (
                          <FormControl className="width100px marginRight10">
                            <Select
                              value={country ? country : "+91"}
                              onChange={handleChange}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem className="colorBlack" value={"+91"}>
                                +91
                              </MenuItem>
                            </Select>
                          </FormControl>
                        )}
                        <FormControl fullWidth className="commonFormControl">
                          {ele?.options ? (
                            <CustomSelect
                              {...register(ele?.name, {
                                required: ele?.required || false,
                              })}
                              onChange={(e) => handleInput(e)}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <InputLabel  
                                className="colorGrey marginLeft16"
                              >
                                <Typography className="colorGrey" variant="body2">
                                {ele?.placeholder}
                              </Typography>
                              </InputLabel>
                              {ele?.options.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </CustomSelect>
                          ) : ele?.radio ? (
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={ele?.value}
                                onChange={(e) => {
                                  setValue(ele?.name, e.target.value);
                                }}
                              >
                                {ele?.radio.map((value) => (
                                  <FormControlLabel
                                    key={value?.name}
                                    value={value?.value}
                                    control={<Radio />}
                                    label={value?.label}
                                  />
                                ))}
                              </RadioGroup>
                            </FormControl>
                          ) : ele?.autoComplete ? (
                            <Autocomplete
                              multiple
                              id="size-small-standard-multi"
                              size="medium"
                              options={props?.optionData}
                              getOptionLabel={(option) => (
                                <span className="flexDirection">
                                  {option?.img?.url && (
                                    <img
                                      className="marginRight6"
                                      loading="lazy"
                                      width="20"
                                      height="20"
                                      src={option?.img?.url}
                                      onError={handleOnError}
                                    />
                                  )}
                                  {option.name}
                                </span>
                              )}
                              defaultValue={facilities}
                              filterSelectedOptions
                              onChange={handleAuto}
                              isOptionEqualToValue={(val, label) =>
                                val.id === label.id
                              }
                              renderOption={(props, option) => (
                                <Box
                                  component="li"
                                  className="marginRight6"
                                  {...props}
                                >
                                  {option?.img?.url && (
                                    <IconButton color="primary">
                                      <img
                                        loading="lazy"
                                        width="20"
                                        height="20"
                                        src={option?.img?.url}
                                        alt=""
                                      />
                                    </IconButton>
                                  )}
                                  {option.name}
                                </Box>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  margin="normal"
                                  aria-label="Add Facilites"
                                  placeholder={ele?.placeholder}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "disabled", // disable autocomplete and autofill
                                  }}
                                />
                              )}
                            />
                          ) : ele?.type !== 'file' &&(
                            <BootstrapInput
                              placeholder={ele?.placeholder}
                              {...register(ele?.name, {
                                required: ele?.required || false,
                                onChange: (e) => {
                                  handleInput(e);
                                },
                              })}
                              type={ele?.type || "text"}
                              id="bootstrap-input"
                              error={errors[ele?.name] || formError[ele?.name]}
                              disabled={
                                ele?.editProps && props?.editIconId === ele?.id
                                  ? false
                                  : ele?.disabled || false
                              }
                              multiline={ele?.multiline || false}
                              rows={ele?.row || ""}
                              defaultValue={ele?.defaultValue}
                              endAdornment={
                                <InputAdornment
                                  className="margin0"
                                  position="start"
                                >
                                  {ele?.disabled &&
                                    ele?.disabled === true &&
                                    !ele?.editProps && (
                                      <IconButton className="editIconCommon cursorAuto">
                                        <img
                                          src={lockicon}
                                          alt="lockicon"
                                        />
                                      </IconButton>
                                    )}
                                </InputAdornment>
                              }
                            />
                          )}
                        </FormControl>
                        {ele?.editProps && props?.editIconId === ele?.id ? (
                          <Box>
                            <Grid
                              container
                              xs={12}
                              sm={12}
                              className="verifyButtonAlign"
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className={`mt0 ${
                                    isDisabled ? "verifyDisabled" : "verifyBtn"
                                  }`}
                                  type="verify"
                                  fullWidth
                                  disabled={isDisabled}
                                >
                                  Verify
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  size="medium"
                                  className="cancelButton"
                                  type="cancel"
                                  fullWidth
                                  onClick={() => handleEditIconClick("")}
                                >
                                  Cancel
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        ) : null}
                      </Box>
                      {/* errors will return when field validation fails  */}
                      {errors[ele?.name] && (
                        <div className="errorMessage">
                          This field is required
                        </div>
                      )}
                      {formError[ele?.name] && (
                        <div className="errorMessage">
                          {formError[ele?.name]}
                        </div>
                      )}
                      {props?.locationError && (
                        <div className="colorRed">{props?.locationError}</div>
                      )}
                    </FormControl>
                  </Box>
                )}
              {(ele?.name === "InsuranceFile" ||
                ele?.name === "PollutionFile" ||
                ele?.name === "RCBookFile" ||
                ele.name === "") && (
                <Button
                  variant="contained"
                  component="label"
                  className="uploadDocsBtn"
                >
                  <img src={cloudArrowUp} alt="profile" />
                  <span className="uploadTextStyle">Upload</span>
                  <input type="file" hidden />
                </Button>
              )}
            </div>
          ))}
          {props?.button && props?.button !== "dialogButton" && (
            <Box>
              <Grid container>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="medium"
                    className={`buttonSubmit ${
                      isDisabled ? "buttonSubmitDisabled" : ""
                    }`}
                    type="submit"
                    fullWidth
                    disabled={isDisabled} // Disable button if no form field value is present
                  >
                    {props.loading ? <Loader /> : props?.button}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
          {props?.button && props?.button === "dialogButton" && (
            <Box>
              <Grid container className="btnDialogContainer">
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className="cancelAddBtn"
                    fullWidth
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={5}>
                  <Button
                    variant="contained"
                    size="medium"
                    className={`buttonSubmit ${
                      isDisabled ? "buttonSubmitDisabled" : ""
                    }`}
                    type="submit"
                    fullWidth
                    disabled={isDisabled}
                  >
                    {props?.selectType === "edit"
                      ? "Update"
                      : props?.selectType === "Send"
                      ? "Send"
                      : "Create"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          )}
        </form>
      </div>
    </div>
  );
}
